import React, { Component } from 'react'
import { Link } from "react-router-dom";
import heroFront from '../imgs/home-image_front.svg';
import heroBack from '../imgs/home-image_back.svg';
import workCoverOne from '../imgs/home-image_work-covers-01.svg';
import workCoverTwo from '../imgs/home-image_work-covers-02.svg';
import workCoverThree from '../imgs/home-image_work-covers-03.svg';
import workCoverFour from '../imgs/home-image_work-covers-04.svg';
import workCoverFive from '../imgs/home-image_work-covers-05.svg';
import workCoverSix from '../imgs/home-image_work-covers-06.svg';
import workCoverOneSmall from '../imgs/home-image_work-covers-01.svg';
import workCoverTwoSmall from '../imgs/home-image_work-covers-02.svg';
import workCoverThreeSmall from '../imgs/home-image_work-covers-03.svg';
import workCoverFourSmall from '../imgs/home-image_work-covers-04.svg';
import workCoverFiveSmall from '../imgs/home-image_work-covers-05.svg';
import workCoverSixSmall from '../imgs/home-image_work-covers-06.svg';
import CoverSmall from '../imgs/hero-small.png';

import XRayMe from "./XRayMe";
import '../css/animations.css';

class Work extends Component {


  render() {

    return (
      <section>
        <div className="hero-block container position-relative">
          <div className="xray-hero-wrapper d-none d-lg-block">
            <XRayMe className="xray-head-image" imgBottom={heroFront} imgTop={heroBack} radius={0.15} alt="UX/UI Designer"/>
          </div>
          <div className="xray-hero-wrapper d-block d-lg-none">
            <div className="xray-wrap">
              <img className="xray-head-image xray-svg" src={heroFront} alt="UX/UI Designer"/>
            </div>
          </div>
        </div>
        <div className="container work-cover-wrapper my-5 my-md-5">
          <div className="row">
            <div className="col-12 col-md-6 my-3 my-lg-4">
              <div className="work-item overflow-hidden">
                <div className="work-item-inner">
                  <Link to="/work/1">
                    <img className="work-img d-none d-md-block" src={workCoverOne} alt="work" />
                    <img className="work-img d-md-none" src={workCoverOneSmall} alt="work" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 my-3 my-lg-4">
              <div className="work-item overflow-hidden">
                <div className="work-item-inner">
                  <Link to="/work/2">
                    <img className="work-img d-none d-md-block" src={workCoverTwo} alt="work" />
                    <img className="work-img d-md-none" src={workCoverTwoSmall} alt="work" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 my-3 my-lg-4">
              <div className="work-item overflow-hidden">
                <div className="work-item-inner">
                  <Link to="/work/3">
                    <img className="work-img d-none d-md-block" src={workCoverThree} alt="work" />
                    <img className="work-img d-md-none" src={workCoverThreeSmall} alt="work" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 my-3 my-lg-4">
              <div className="work-item overflow-hidden">
                <div className="work-item-inner">
                  <Link to="/work/4">
                    <img className="work-img d-none d-md-block" src={workCoverFour} alt="work" />
                    <img className="work-img d-md-none" src={workCoverFourSmall} alt="work" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 my-3 my-lg-4">
              <div className="work-item overflow-hidden">
                <div className="work-item-inner">
                  <Link to="/work/5">
                    <img className="work-img d-none d-md-block" src={workCoverFive} alt="work" />
                    <img className="work-img d-md-none" src={workCoverFiveSmall} alt="work" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 my-3 my-lg-4">
              <div className="work-item overflow-hidden">
                <div className="work-item-inner">
                  <Link to="/work/6">
                    <img className="work-img d-none d-md-block" src={workCoverSix} alt="work" />
                    <img className="work-img d-md-none" src={workCoverSixSmall} alt="work" />
                  </Link>
                </div>
              </div>
            </div>
          </div>          
        </div>
      </section>
    )
  }
}

export default Work